import React, { useEffect, useState } from 'react'
import {
  Create,
  TextInput,
  useTranslate,
  useNotify,
  TabbedForm,
  FormTab,
  useRedirect,
  BooleanInput,
  required,
  FormDataConsumer,
  NumberInput,
  ImageInput,
  ImageField,
  TabbedFormTabs,
} from 'react-admin'

import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { countryServices } from 'src/services/reservation/country/country.service'
import { businessTypeServices } from 'src/services/reservation/businessType/businessType.service'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { FieldArray } from './logic/ArrayInput'
import { FieldArrayProduct } from './logic/ArrayInputProduct'
import { FormFiscalData } from './logic/FormFiscalData'
import { productServices } from 'src/services/reservation/product/product.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { userServices } from 'src/services/reservation/user/user.service'
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'
import { Notification } from 'src/components/pages/administration/work-unit/logic/Notification'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { getAllChildrensId } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getAllChildrensId'
import { FieldArrayBanner } from './logic/ArrayInputBanner'
import { bannerServices } from 'src/services/reservation/banner/Banner.service'
import { FieldArrayLanding } from './logic/ArrayInputLanding'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_GET } from 'src/helper/Permission'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

export const BusinessUnitCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [countryList, setCountryList] = useState([])
  const [loadingCountryList, setLoadingCountryList] = useState(false)
  const [businessTypeList, setBusinessTypeList] = useState([])
  const [loadingBusinessTypeList, setLoadingBusinessTypeList] = useState(false)
  const [businessUnitList, setBusinessUnitList] = useState([])
  const [loadingBusinessUnit, setLoadingBusinessUnit] = useState(false)
  const [workUnitList, setWorkUnitList] = useState([])
  const [loadingWorkUnitList, setLoadingWorkUnitList] = useState(false)
  const [workUnit, setWorkUnit] = useState(null)
  const [userListManagerResposible, setUserListManagerResposible] = useState([])
  const [userListCommercialResposible, setUserListCommercialResposible] = useState([])
  const [loadingUserListManagerResposible, setLoadingUserListManagerResposible] = useState(false)
  const [loadingUserListCommercialResposible, setLoadingUserListCommercialResposible] = useState(false)
  const [productByBusinessUnitList, setProductByBusinessUnitList] = useState(null)
  const [loadingProductByBusinessUnitList, setLoadingProductByBusinessUnitList] = useState(false)
  const [productList, setProductList] = useState([])
  const [loadingProductList, setLoadingProductList] = useState(false)
  const [basesList, setBasesList] = useState([])
  const [loadingBasesList, setLoadingBasesList] = useState(false)

  useEffect(() => {
    getBusinessType()
    getProducts()
    // getUser()
    getBases()
    // getBusinessUnit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getWorkUnit = async (long_name) => {
    try {
      setLoadingWorkUnitList(true)
      const allWorkUnit = await workUnitServices.getByAll({ long_name: long_name })
      setWorkUnitList(allWorkUnit)
      setLoadingWorkUnitList(false)
    } catch (error) {
      setWorkUnitList([])
      setLoadingWorkUnitList(false)
    }
  }

  const getWorkUnitByid = async (id) => {
    try {
      setLoadingProductByBusinessUnitList(true)
      const work_unit = await workUnitServices.getById(id)
      if (work_unit) {
        setWorkUnit(work_unit)

        const products = [
          ...new Set([
            ...work_unit.product_by_work_unit_inheritance || [],
            ...work_unit.product_by_work_unit_relation || []
          ])
        ]
        setProductByBusinessUnitList(products)
      }
      setLoadingProductByBusinessUnitList(false)
    } catch (error) {
      setWorkUnit(null)
      console.log('getWorkUnitByid error', error)
    }
  }

  const getBusinessUnit = async (long_name) => {
    try {
      setLoadingBusinessUnit(true)
      if (workUnit) {
        const workUnitIds = getAllChildrensId(workUnit)
        const allBusinessUnit = await businessUnitServices.getByAll({
          long_name: long_name,
          fantasy_name: long_name,
          operator: 'or_ilike',
          limit: 15,
        })
        const allBusinessUnitFilter = allBusinessUnit.filter((businessUnit) =>
          workUnitIds.includes(businessUnit?.work_unit_id)
        )
        setBusinessUnitList(allBusinessUnitFilter)
        return
      }

      setBusinessUnitList([])
    } catch (error) {
      setBusinessUnitList([])
    } finally {
      setLoadingBusinessUnit(false)
    }
  }

  let searchTimeoutCountry

  const getCountry = async (long_name) => {
    clearTimeout(searchTimeoutCountry)

    searchTimeoutCountry = setTimeout(async () => {
      try {
        setLoadingCountryList(true)
        const allCountries = await countryServices.getByAll({ long_name: long_name })
        setCountryList(allCountries)
        setLoadingCountryList(false)
      } catch (error) {
        setCountryList([])
        setLoadingCountryList(false)
      }
    }, 700)
  }

  const getBusinessType = async () => {
    try {
      setLoadingBusinessTypeList(true)
      const allBusinessType = await businessTypeServices.getByAll()
      setBusinessTypeList(allBusinessType)
      setLoadingBusinessTypeList(false)
    } catch (error) {
      setBusinessTypeList([])
      setLoadingBusinessTypeList(false)
    }
  }


  let searchTimeoutManagerResposible 
  let searchTimeoutCommercialResposible

  const getUserB2ManagerResposible = async (user, length = 2) => {
    clearTimeout(searchTimeoutManagerResposible)

    if (
      (!user?.firstname || user.firstname.length < length) &&
      (!user?.surname || user.surname.length < length)
    ) {
      setUserListManagerResposible([])
      return
    }

    searchTimeoutManagerResposible = setTimeout(async () => {
      try {
        setLoadingUserListManagerResposible(true)
        let filter = {
          limit: 20,
        }
        if (user?.firstname) {
          filter.firstname = user?.firstname
        }
        if (user?.surname) {
          filter.surname = user?.surname
        }
        const allUser = await reservationServices.userReservtionFilter(filter)
        setUserListManagerResposible(allUser)
      } catch (error) {
        setUserListManagerResposible([])
      } finally {
        setLoadingUserListManagerResposible(false)
      }
    }, 1000)
  }

  const getUserB2CommercialResposible = async (user, length = 2) => {
    clearTimeout(searchTimeoutCommercialResposible)

    if (
      (!user?.firstname || user.firstname.length < length) &&
      (!user?.surname || user.surname.length < length)
    ) {
      setUserListCommercialResposible([])
      return
    }

    searchTimeoutCommercialResposible = setTimeout(async () => {
      try {
        setLoadingUserListCommercialResposible(true)
        let  filter = {
          limit: 20
        }
        if (user?.firstname) {
          filter.firstname = user?.firstname
        }
        if (user?.surname) {
          filter.surname = user?.surname
        }
        const allUser = await reservationServices.userReservtionFilter(filter)
        setUserListCommercialResposible(allUser)
      } catch (error) {
        setUserListCommercialResposible([])
      } finally {
        setLoadingUserListCommercialResposible(false)
      }
    }, 1000)
  }


  const getProducts = async () => {
    try {
      setLoadingProductList(true)
      const allProducts = await productServices.getByWorkUnit()
      setProductList(allProducts)
      setLoadingProductList(false)
    } catch (error) {
      setProductList([])
      setLoadingProductList(false)
    }
  }

  const getBases = async () => {
    setLoadingBasesList(true)
    try {
      const allBases = await reservationServices.getAllAlternativeBases()
      if (allBases) {
        setBasesList(allBases.map(elem => ({ name: elem })))
        setLoadingBasesList(false)
        return
      }
      notify(`bases not found`, { type: 'error' })
      setLoadingBasesList(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingBasesList(false)
    }
  }

  const onChangeWorkUnit = (e) => {
    const workUnit = e.target.value
    getWorkUnitByid(workUnit?.id)
  }

  const onChangeBusinessUnit = (e) => {
    setLoadingProductByBusinessUnitList(true)
    const businessUnit = e.target.value

    const products = [
      ...new Set([
        ...workUnit.product_by_work_unit_inheritance || [],
        ...workUnit.product_by_work_unit_relation || [],
        ...businessUnit.product_work_unit_by_business_unit_relation || [],
        ...businessUnit.product_relation || [],
      ])
    ]
    setProductByBusinessUnitList(products)
    setLoadingProductByBusinessUnitList(false)
  }

  const createBannersByBusinessUnit = async (businessUnitId, banners) => {
    const bannersToCreate = banners.filter((elem) => elem?.banner_id && elem?.new_register)
    if (bannersToCreate.length > 0) {
      try {
        const promises = bannersToCreate.map(async (elem) => {
          delete elem.new_register
          delete elem.banner_relation
          elem.business_unit_id = businessUnitId
          const response = await bannerServices.createBannerByBusinessUnit(elem)
          return response
        })

        const results = await Promise.all(promises)
        return results
      } catch (error) {
        notify(`ra.notification.create_error_banner_by_business_unit`, {
          type: 'error',
        })
        return false
      }
    }

    return true
  }

  const onSuccess = async (data) => {
    try {
      if (data.banner_relation) {
        await createBannersByBusinessUnit(data.id, data.banner_relation);
      }
    } catch (error) {
      // console.log("error", error);
    } finally{
      notify('ra.notification.created_success_masculine', {
        type: 'success',
        messageArgs: { element: translate('ra.single_entity.business-unit') },
      })
      redirect('/business-unit')
    }
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.business-unit') },
    })
  }

  const is_fiscal_data_relation_null = (fiscal_data) => {
    if (fiscal_data) {
      const props = Object.keys(fiscal_data)
      if (props.length !== 0) {
        let someFieldComplete = []
        props.forEach((prop) => {
          if (fiscal_data[prop] !== null && fiscal_data[prop] !== undefined) {
            someFieldComplete.push(fiscal_data[prop])
          }
        })
        if (someFieldComplete.length >= 1) {
          return false
        }
        return true
      }
    }
    return false
  }

  const formatData = (data) => {
    const newData = { ...data }
    if (data?.work_unit_id && typeof data?.work_unit_id != 'number') {
      newData.work_unit_id = newData?.work_unit_id?.id
    }
    if (data?.parent_id && typeof data?.parent_id != 'number') {
      newData.parent_id = newData?.parent_id?.id
    }
    if (data?.country_id && typeof data?.country_id != 'number') {
      newData.country_id = newData?.country_id?.id
    }
    if (data?.landing_relation?.length > 0) {
      newData?.landing_relation?.forEach(elem => {
        elem.landing_id = elem.landing_id || elem.landing_relation?.id
        delete elem.landing_relation
      })
    }
    if (data?.banner_relation?.length > 0) {
      newData?.banner_relation?.forEach(elem => {
        elem.banner_id = elem.banner_id || elem.banner_relation?.id
        delete elem.banner_relation
      })
    }
    return newData
  }

  const transform = (data) => {
    data?.product_work_unit_by_business_unit_relation?.forEach((elem) => {
      elem.product_by_work_unit_id = elem.product_by_work_unit_relation.id
      delete elem.product_by_work_unit_relation
    })
    // if (data?.fiscal_data_relation?.type_responsible_id !== CONSUMIDOR_FINAL_ID) {
    //   // short_name and long_name will be null if type_responsible is not CONSUMIDOR_FINAL,
    //   // then we let`s to assign BusinessName value
    //   const BusinessName = data.fiscal_data_relation.name //razon social
    //   data.short_name = BusinessName
    //   data.long_name = BusinessName
    // } PORQUE NO NOS ACORDAMOS PARA QUE ERA
    if (is_fiscal_data_relation_null(data?.fiscal_data_relation)) delete data.fiscal_data_relation
    if (data?.is_agency === false) {
      data.agency_id = null
    }

    if (data?.excluded_products) {
      data.excluded_product_id = data.excluded_products.map(elem => elem.id)
      delete data.excluded_products
    }

    if (data?.user_id){
      data.user_id = data?.user_id?.id_reservation_user
    }

    if (data?.salesperson_user_id){
      data.salesperson_user_id = data?.salesperson_user_id?.id_reservation_user
    }

    return formatData(data)
  }

  const addUserId = (userList) =>{
    try {
      return userList?.map((user) => {
        return {
          ...user,
          user_id: user?.id
        }
      })
    } catch (error) {
      console.log('error', error)
      
      return []
    }
  }

  return (
    <Create {...props} transform={transform} mutationOptions={{ onSuccess, onError }} actions={null}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CardCommon title={translate('ra.title.create_businessUnit')}>
            <TabbedForm
              toolbar={<CardCrudBottomButtons btnSave={true} />}
              tabs={<TabbedFormTabs variant='scrollable' scrollButtons='auto' />}
            >
              <FormTab label={translate('ra.field.fiscal_data')}>
                <FormFiscalData />
              </FormTab>
              <FormTab label={translate('ra.title.customer_file')}>
                <Grid container spacing={3}>
                  <EditInputsWrap label={translate('ra.field.logo')}>
                    <ImageInput source='logo' label={''} className='image-input'>
                      <ImageField source='src' title='title' />
                    </ImageInput>
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.logo_voucher')}>
                    <ImageInput source='logo_voucher' label={''} className='image-input'>
                      <ImageField source='src' title='title' />
                    </ImageInput>
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.email')} required>
                    <TextInput source='email' label='' fullWidth validate={[required()]} />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.phone')}>
                    <NumberInput source='phone' label='' fullWidth />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.description')}>
                    <TextInput source='description' label='' fullWidth />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.country')} required>
                    <AutocompleteInput
                      source='country_id'
                      options={countryList}
                      loading={loadingCountryList}
                      optionsText={['long_name']}
                      onSearch={getCountry}
                      resetOnLoad={false}
                    />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.state')}>
                    <TextInput source='state' label='' fullWidth />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.address')}>
                    <TextInput source='address' label='' fullWidth />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.contact')}>
                    <TextInput source='contact' label='' fullWidth />
                  </EditInputsWrap>
                  <EditInputsWrap
                    label={translate('ra.field.manager_responsible')}
                    required
                    tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
                  >
                    <MultiAutocompleteInput
                      source='user_id'
                      options={addUserId(userListManagerResposible)}
                      loading={loadingUserListManagerResposible}
                      optionsText={['firstname', 'surname']}
                      separator=' '
                      optionValue='id'
                      onSearch={getUserB2ManagerResposible}
                      resetOnLoad={false}
                      fields={['firstname', 'surname']}
                      validate={[required()]}
                    />
                  </EditInputsWrap>
                  <EditInputsWrap
                    label={translate('ra.field.commercial_responsible')}
                    required
                    tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
                  >
                    <MultiAutocompleteInput
                      source='salesperson_user_id'
                      options={addUserId(userListCommercialResposible)}
                      loading={loadingUserListCommercialResposible}
                      optionsText={['firstname', 'surname']}
                      separator=' '
                      optionValue='id'
                      onSearch={getUserB2CommercialResposible}
                      resetOnLoad={false}
                      fields={['firstname', 'surname']}
                      validate={[required()]}
                    />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.business_type')} required>
                    {loadingBusinessTypeList ? (
                      <Skeleton variant='rectangular' width={'100%'} height={40} />
                    ) : (
                      <SelectInput
                        size='small'
                        optionsText={['long_name']}
                        source='business_type_id'
                        options={businessTypeList}
                        fullWidth
                        label=''
                        validate={[required()]}
                      />
                    )}
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.work_unit')} required>
                    <AutocompleteInput
                      source='work_unit_id'
                      options={workUnitList}
                      loading={loadingWorkUnitList}
                      optionsText={['long_name']}
                      onSearch={getWorkUnit}
                      onChange={onChangeWorkUnit}
                      resetOnLoad={false}
                      validate={[required()]}
                    />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.parent_businessunit')}>
                    <FormDataConsumer>
                      {({ formData }) => {
                        return (
                          <AutocompleteInput
                            source='parent_id'
                            options={businessUnitList}
                            loading={loadingBusinessUnit}
                            optionsText={['long_name', 'fiscal_data_relation.name', 'fantasy_name']}
                            onSearch={getBusinessUnit}
                            onChange={onChangeBusinessUnit}
                            disabled={!formData?.work_unit_id && !workUnit}
                          />
                        )
                      }}
                    </FormDataConsumer>
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.json')} xs={12} md={6} lg={6}>
                    <JsonInput source='config' width='auto' />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.url')}>
                    <TextInput source='url' label='' fullWidth />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.state')}>
                    <BooleanInput
                      label={translate('ra.field.is_active')}
                      source='is_active'
                      fullWidth
                      defaultValue={true}
                    />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.is_agency')}>
                    <BooleanInput label={translate('ra.field.is_agency')} source='is_agency' fullWidth />
                  </EditInputsWrap>

                  <FormDataConsumer>
                    {({ formData }) =>
                      formData?.is_agency && (
                        <EditInputsWrap label={translate('ra.field.file_number')}>
                          <NumberInput label='' source='agency_id' fullWidth />{' '}
                        </EditInputsWrap>
                      )
                    }
                  </FormDataConsumer>
                </Grid>
              </FormTab>

              <FormTab label={translate('ra.field.currency')}>
                <Grid container spacing={3}>
                  <FieldArray />
                </Grid>
              </FormTab>
              <FormTab label={translate('ra.field.product')}>
                <Grid container spacing={3}>
                  <FieldArrayProduct
                    productList={productList}
                    loadingProductList={loadingProductList}
                    productByBusinessUnitList={productByBusinessUnitList}
                    loadingProductByBusinessUnitList={loadingProductByBusinessUnitList}
                  />
                </Grid>
              </FormTab>
              {hasPermissionFunction('banner', PERMISSION_GET) && (
                <FormTab label={translate('ra.field.banner')}>
                  <Grid container spacing={3}>
                    <FieldArrayBanner />
                  </Grid>
                </FormTab>
              )}
              {hasPermissionFunction('landing', PERMISSION_GET) && (
                <FormTab label={translate('ra.field.landing')}>
                  <Grid container spacing={3}>
                    <FieldArrayLanding />
                  </Grid>
                </FormTab>
              )}
              <FormTab label={translate('ra.title.notification')}>
                <Grid container spacing={3}>
                  <Notification />
                </Grid>
              </FormTab>
              {hasPermissionFunction('billing', 'config') && (
                <FormTab label={translate('ra.title.billing')}>
                  <Grid container spacing={3}>
                    <EditInputsWrap label={translate('ra.field.billing_default_base')}>
                      {loadingBasesList ? (
                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                      ) : (
                        <SelectInput
                          size='small'
                          optionsText={['name']}
                          optionValue='name'
                          fullWidth
                          label={false}
                          source='billing_default_base'
                          options={basesList}
                          showSearch
                        />
                      )}
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.billing_alternate_base')}>
                      {loadingBasesList ? (
                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                      ) : (
                        <SelectInput
                          size='small'
                          optionsText={['name']}
                          optionValue='name'
                          fullWidth
                          label={false}
                          source='billing_alternate_base.options'
                          options={basesList}
                          showSearch
                          multiple
                        />
                      )}
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.auto_billable')}>
                      <BooleanInput
                        label={translate('ra.field.auto_billable')}
                        source='auto_billable'
                        fullWidth
                        defaultValue={true}
                      />
                    </EditInputsWrap>
                  </Grid>
                </FormTab>
              )}
            </TabbedForm>
          </CardCommon>
        </Grid>
      </Grid>
    </Create>
  )
}
